import request from '../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../types/enums/request-enums';

const GetAIGenerationTypes = (params?: {
    name?: string;
    isActive?: boolean;
    pageNumber?: number;
    pageSize?: number;
}): Promise<any> => {
    const queryParams = new URLSearchParams();

    if (params?.name) queryParams.append('name', params.name);
    if (params?.isActive !== undefined) queryParams.append('isActive', params.isActive.toString());
    if (params?.pageNumber) queryParams.append('pageNumber', params.pageNumber.toString());
    if (params?.pageSize) queryParams.append('pageSize', params.pageSize.toString());

    return request({
        url: `${ApiURL.Query.StudioQueryURLs.AIGenerationTypeQueryURL.GetAIGenerationTypes}?${queryParams.toString()}`,
        method: RequestType.GET,
    });
};

const GetActiveAIGenerationTypes = (): Promise<any> =>
    request({
        url: ApiURL.Query.StudioQueryURLs.AIGenerationTypeQueryURL.GetActiveAIGenerationTypes,
        method: RequestType.GET,
    });

const GetAIGenerationTypeById = (id: number): Promise<any> =>
    request({
        url: `${ApiURL.Query.StudioQueryURLs.AIGenerationTypeQueryURL.GetAIGenerationTypeById}/${id}`,
        method: RequestType.GET,
    });

const GetAIGenerationTypeByCode = (code: string): Promise<any> =>
    request({
        url: `${ApiURL.Query.StudioQueryURLs.AIGenerationTypeQueryURL.GetAIGenerationTypeByCode}/${code}`,
        method: RequestType.GET,
    });

export const AIGenerationTypeQuery = {
    GetAIGenerationTypes,
    GetActiveAIGenerationTypes,
    GetAIGenerationTypeById,
    GetAIGenerationTypeByCode,
};

export default AIGenerationTypeQuery;

